import React, { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Form, InputGroup, Button, ListGroup, Badge, Accordion, Modal } from "react-bootstrap"; 
import { ReactComponent as Mail } from "../../../assets/images/icon_svg/mail.svg"; 
import { ReactComponent as CreateTemplate } from "../../../assets/images/icon_svg/create_template.svg"; 
import { ReactComponent as Download } from "../../../assets/images/icon_svg/dwnld.svg";  
import { ReactComponent as ColumnIcon } from "../../../assets/images/icon_svg/column.svg"; 
import { ReactComponent as TemplateDwnld } from "../../../assets/images/icon_svg/template_dwnld.svg"; 
import "../../../assets/css/s_recovery/export/export.css";
import { CallApi } from '../../../Components/common/CommonFunctions';
import { withRFSToken } from '../../../Services/axios';
import * as XLSX from 'xlsx';

const Export = () => {
  const [show, setShow] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [downloadingId, setDownloadingId] = useState(null);
  const isMounted = useRef(false);
  const [disLoading, setDisLoading] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
 
  const initialData = [
    "Irregularity Type",
    "Pieces Involved",
    "Weight Involved",
    "Flight No.",
    "Flight Date",
    "Record Age",
    "Recovery Phase",
    "Region",
  ];
 
  const [available, setAvailable] = useState(initialData);
  const [selected, setSelected] = useState([]);
  const [dragIndex, setDragIndex] = useState(null);

  const exportList = () => {
    CallApi({
      endPoint: "v2/service-recovery/export-list",
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          const parsed = res.data.response_data.map((template) => {
            const parsedFields = template.fields ? JSON.parse(template.fields) : {};
            return {
              ...template,
              fields: parsedFields,
              column_count: Object.keys(parsedFields).length,
            };
          });
          setTemplateList(parsed);
        }
      },
      onError: (msg) => console.error("Export list error:", msg),
    });
  };

  useEffect(() => {
    if (isMounted.current) return;
    exportList();
    isMounted.current = true;
  }, []);

 const handleDownload = async (template) => {
  try {
    setDownloadingId(template.id);
    setDisLoading(true);
    const res = await withRFSToken.post("v2/service-recovery/download-export", { id: template.export_id ?? template.id },
      {
        responseType: "blob",
      }
    );
    const now = new Date();
    const formattedDateTime =
      `${String(now.getDate()).padStart(2, '0')}-` +
      `${String(now.getMonth() + 1).padStart(2, '0')}-` +
      `${now.getFullYear()} `;
    const blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${template?.title}-${formattedDateTime}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Download error:", err);
  } finally {
    setDownloadingId(null);
    setDisLoading(false);
  }
};
 
  // 👉 Move to right
  const handleAdd = (item) => {
    setSelected([...selected, item]);
  };
 
  // // 👉 Remove (optional)
  // const handleRemove = (item) => {
  //   setAvailable([...available, item]);
  //   setSelected(selected.filter((i) => i !== item));
  // };
 
  // 👉 Drag start
  const handleDragStart = (index) => {
    setDragIndex(index);
  };
 
  // 👉 Drop reorder
  const handleDrops = (index) => {
    if (dragIndex === null) return;
 
    const updated = [...selected];
    const draggedItem = updated[dragIndex];
 
    updated.splice(dragIndex, 1);
    updated.splice(index, 0, draggedItem);
 
    setSelected(updated);
    setDragIndex(null);
  };
  return (
    <>
    {disLoading &&
        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
    }
    <div className="main-content">
      <div className="d-flex gap-2">
            <div className="tw-65 border-end summary_card min-hgt-75">
              {/* <button className="create_btn" onClick={handleShow}><CreateTemplate />Create Template</button> */}
              <div className='text-center pt-5 data_not_found'>
                <h4>Export Builder Coming Soon</h4>
                <p>Custom export configuration is currently under development.<br/> Use the recommended templates on the right to download your data.</p>
              </div>
            </div>
            <div className="tw-35 summary_card min-hgt-75">
              <div class="info_card_title"><h6>Recommended Templates</h6><p>Predefined templates for common exports</p></div>
               <div className="template_wrap">
                    {templateList.length === 0 ? (
                      <p className="text-muted text-center pt-3">No templates available.</p>
                    ) : (
                      templateList.map((template) => (
                        <div className="template_card mb-3" key={template.id}>
                          <div className="d-flex align-items-start justify-content-between border-bottom border-1 mb-2">
                            <div className="info_card_title">
                              <h6>{template.title}</h6>        
                              <p>{template.description}</p>
                            </div>
                            <div className="mt-1">
                              <Button
                                variant="link"
                                className="p-0"
                                onClick={() => handleDownload(template)}
                                title="Download"
                              >
                                <Download />
                              </Button>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span><ColumnIcon />{template.column_count} Columns</span>
                          </div>
                        </div>
                      ))
                    )}
              </div>
          </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="primary_modal modal_bgw recoveryCase"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Create Template <br />
            <p>Select columns and configure your excel export format</p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex gap-3 crt_tmplt">
            <div className="tw-60 border-end">
              <div className="avalbl_Clumn">
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Available Columns</h5>
                  <span>28 Columns</span>
                </div>
                {/* <Accordion defaultActiveKey={["0", "1", "2"]} alwaysOpen className="p-3">

                  
                  <Accordion.Item eventKey="0" className="mb-3">
                    <Accordion.Header>Irregularity Information</Accordion.Header>
                    <Accordion.Body className="rounded p-3">

                      <div className="d-flex flex-wrap gap-2">
                        <button className="chip">Irregularity Type</button>
                        <button className="chip">Pieces Involved</button>
                        <button className="chip">Weight Involved</button>

                        <button className="chip">Flight No.</button>
                        <button className="chip">Flight Date</button>
                        <button className="chip">Record Age</button>
                        <button className="chip">Recovery Phase</button>

                        <button className="chip">Region</button>
                      </div>

                    </Accordion.Body>
                  </Accordion.Item>

                  
                  <Accordion.Item eventKey="1" className="mb-3">
                    <Accordion.Header>Shipment Information</Accordion.Header>
                    <Accordion.Body className="rounded p-3">

                      <div className="d-flex flex-wrap gap-2">
                        <button className="chip">Total Pieces</button>
                        <button className="chip">Total Weight</button>
                        <button className="chip">Nature of Goods</button>

                        <button className="chip">SHC</button>
                        <button className="chip">Freight Type</button>
                        <button className="chip">Product Code</button>
                        <button className="chip">Shipper</button>
                        <button className="chip">Consignee</button>

                        <button className="chip">Agent</button>
                      </div>

                    </Accordion.Body>
                  </Accordion.Item>

                  
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>Shipment Route</Accordion.Header>
                    <Accordion.Body className="rounded p-3">

                      <div className="d-flex flex-wrap gap-2">
                        <button className="chip">Origin</button>
                        <button className="chip">Origin - Handler</button>
                        <button className="chip">Destination</button>
                        <button className="chip">Destination - Handler</button>

                        <button className="chip">Reporting Station</button>
                        <button className="chip">Reporting Station - Handler</button>
                      </div>

                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion> */}
                <Accordion defaultActiveKey={["0"]} alwaysOpen className="p-3">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Irregularity Information</Accordion.Header>
                    <Accordion.Body>
                      <div className="d-flex flex-wrap gap-2">
                        {available.map((item, index) => (
                          <button
                            key={index}
                            className="chip"
                            onClick={() => handleAdd(item)}
                          >
                            {item}
                          </button>
                        ))}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
            <div className="tw-40 avalbl_Clumn">
              <div className="d-flex justify-content-between align-items-center">
                <h5>Selected Columns</h5>
                <span>12 Columns</span>
              </div>
              <div className="p-2">
                <h6>AWB No.</h6>
                
                <div className="min-height">
                  {selected.map((item, index) => (
                    <div
                      key={index}
                      className="drag-item d-flex gap-2"
                      draggable
                      onDragStart={() => handleDragStart(index)}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={() => handleDrops(index)}
                    >
                      <span className="drag-handle">⋮⋮</span>
                      {item}

                      {/* optional remove */}
                      {/* <span
                        className="remove-btn"
                        onClick={() => handleRemove(item)}
                      >
                        ✕
                      </span> */}
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary">
            Save Template
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </>
  )
}

export default Export